import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MatSnackBarModule, MatCardModule, MatStepperModule, MatTabsModule, MatIconModule } from '@angular/material';
import { NgxLoadingModule, } from 'ngx-loading';
import {MatDialogModule} from '@angular/material';
import { AdoptionComponent } from '../adoption/adoption.component';
import { AddoptionmainComponent } from './addoptionmain/addoptionmain.component';
import { AdoptionlistComponent } from './adoptionlist/adoptionlist.component';
import {adoptionRouting} from './adoption.route';
import { AdoptionformComponent } from './adoptionform/adoptionform.component';

import {Ng2UploaderModule} from 'ng2-uploader';

import { AdoptionrequestComponent } from './adoptionrequest/adoptionrequest.component';
import { AdoptionrequestdetailComponent } from './adoptionrequestdetail/adoptionrequestdetail.component';
import { PendingupdationComponent } from './pendingupdation/pendingupdation.component';
import { SharedModule } from '../common/shared.module';
import { FilterModule } from '../filter/filter.module';
import { KnowmeComponent } from './knowme/knowme.component';
@NgModule({
    imports: [
      CommonModule,
      FlexLayoutModule,
      FormsModule,
      NgbModule,
      ReactiveFormsModule,
      NgxLoadingModule,
      RouterModule,
      MatDialogModule,
      adoptionRouting,
      Ng2UploaderModule,
      SharedModule,
      FilterModule,
      NgxLoadingModule,
      MatDialogModule,MatSnackBarModule,MatCardModule,MatStepperModule,MatTabsModule,
      MatIconModule
    ],
    declarations: [
        AdoptionComponent,
        AddoptionmainComponent,
        AdoptionlistComponent,
        AdoptionformComponent,
        AdoptionrequestComponent,
        AdoptionrequestdetailComponent,
        PendingupdationComponent ,
        KnowmeComponent
       ],
       entryComponents: [AdoptionrequestdetailComponent],
       schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    })
    export class AdoptionModule {}
